import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function OurStorySection() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left: image */}
          <div className="w-full lg:w-2/5">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20cold%20storage%20facility%20interior%20in%20India%20with%20organized%20frozen%20food%20pallets%2C%20industrial%20blue%20lighting%2C%20professional%20workers%20in%20insulated%20protective%20gear%20managing%20inventory%20with%20digital%20tablets%2C%20clean%20metallic%20racking%20systems%2C%20cold%20mist%20atmosphere%2C%20editorial%20documentary%20photography%20style%20with%20warm%20accent%20lighting%20on%20faces%2C%20high%20detail%20wide%20composition&width=700&height=560&seq=freshhlock-our-story&orientation=landscape"
                alt="Inside a Freshhlock-connected cold storage facility"
                className="w-full aspect-[5/4] object-cover rounded-2xl"
              />
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-brand-900/30 to-transparent"></div>
            </div>
          </div>

          {/* Right: narrative */}
          <div className="w-full lg:w-3/5">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/70 border border-primary-200/50 mb-4">
              <span className="text-xs font-semibold text-primary-700 uppercase tracking-wider">Our Story</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-primary-700 mb-5">
              Every Harvest Has a Moment of Perfection
            </h2>

            <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
              <p>
                India produces an extraordinary abundance of food — seafood from its 7,500-kilometre coastline, poultry from its industrial heartland, vegetables from its fertile plains. But abundance is seasonal. Appetite is constant. The gap between the two has always been absorbed by the producer — the fisherman who sells at the morning market price, the farmer who takes whatever the mandi offers.
              </p>
              <p>
                <strong className="text-primary-700 font-semibold">Freshhlock was founded to move that absorption point.</strong> Instead of forcing the producer to sell at harvest-time prices, we move the produce into a freezer — locking in peak quality — and connect every link in the chain: storage, transport, wholesale, and retail. The result: quality sets the price, not urgency.
              </p>
              <p>
                We don&apos;t own the warehouses, the trucks, or the stores. We build the technology that connects them — a real-time network that maps capacity, matches supply with demand, standardises specifications, and provides full traceability from harvest to freezer. In doing so, we make India&apos;s frozen food chain <strong className="text-primary-700 font-semibold">more efficient, more transparent, and fundamentally fairer</strong> — for everyone in it.
              </p>
              <p>
                Founded by a team with deep experience in cold-chain logistics, food processing, and platform technology, Freshhlock is proving the model in one region before scaling nationally. We believe that India&apos;s $15 billion frozen food opportunity deserves world-class infrastructure. We&apos;re building it.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}